import { render, staticRenderFns } from "./BuildAsmtMessage.vue?vue&type=template&id=e2f2c4f6"
import script from "./BuildAsmtMessage.vue?vue&type=script&lang=js"
export * from "./BuildAsmtMessage.vue?vue&type=script&lang=js"
import style0 from "./BuildAsmtMessage.vue?vue&type=style&index=0&id=e2f2c4f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports